function insert(state, action) {
  const { key, data } = action;
  const existing = state.get(key);

  if (!existing) {
    return state.merge({
      [key]: {
        id: key,
        total: data.total,
        items: data.items.map(item => item.id),
      },
    });
  }

  const { items } = existing.toJS();

  data.items.forEach(item => {
    if (items.indexOf(item.id) === -1) {
      items.push(item.id);
    }
  });

  return state.merge({
    [key]: existing.merge({
      id: key,
      total: data.total,
      items,
    }),
  });
}

function writeEntitiesToCollection(state, action, insertValues) {
  const { key, data } = action;
  const existing = state.get(key);

  if (!existing) {
    return state.merge({
      [key]: {
        id: key,
        total: data.length,
        items: data.map(item => item.id),
      },
    });
  }

  const { items } = existing.toJS();

  insertValues(items, data);

  return state.merge({
    [key]: existing.merge({
      id: key,
      total: items.length,
      items,
    }),
  });
}

function insertByPrepending(target, items) {
  items.forEach(item => {
    if (!target.includes(item.id)) {
      target.unshift(item.id);
    }
  });
}

function insertByAppending(target, items) {
  items.forEach(item => {
    if (!target.includes(item.id)) {
      target.push(item.id);
    }
  });
}

function remove(state, action) {
  const { key, data } = action;
  const existing = state.get(key);

  if (!existing) {
    return state;
  }

  const idsToRemove = data.map(item => item.id);
  const items = existing.toJS().items.filter(id => {
    return idsToRemove.indexOf(id) === -1;
  });

  return state.merge({
    [key]: existing.merge({
      id: key,
      total: items.length,
      items,
    }),
  });
}

export default (Actions, Schema, initialState) => {
  return (state = initialState, action) => {
    switch (action.type) {
      case Actions.INSERT:
        return insert(state, action);

      case Actions.PREPEND:
        return writeEntitiesToCollection(state, action, insertByPrepending);

      case Actions.APPEND:
        return writeEntitiesToCollection(state, action, insertByAppending);

      case Actions.REMOVE:
        return remove(state, action);

      default:
        return state;
    }
  };
};
